// import { useState } from "react";
// import { useSelector } from "react-redux";
// import { CircularProgress } from "@mui/material";
// import { getPaymentMethods } from "@/pages/payment-methods/actions";
// import styled from "styled-components";
// import Sidebar from "@/pages/sidebar/sidebar";
// import ClientMainHeader from "@/pages/header";
// import { LoadingWrapper} from "@/pages/styled";
// import {}
// import { SubmitBtn } from "../../payment-methods/styled";
// import { usePlaidLink } from "react-plaid-link";
// import useLinkToken from "../../plaid/hooks/useLinkToken";
// import setAccessToken from "../../plaid/actions/setAccesToken";
// import { useAuth } from "@/providers/auth";
// import { useHistory } from "react-router-dom";
// import { toast } from "react-toastify";

// const ConnectPaymentMethod = () => {
//   const history = useHistory();
//   const [loading, setLoading] = useState(false);
//   const [selectedPayment, setSelectedPayment] = useState(null);
//   const [paymentList, setPaymentList] = useState([]);

//   const { settingData, businessId } = useSelector((state) => state.account);

//   const [shortCut, setShortCut] = useState("");
//   const [currentWidth, setCurrentWidth] = useState(0);
//   const { cognitoId } = useAuth();

//   const getPaymentMethodList = async () => {
//     setLoading(true);
//     try {
//       const paymentMethods = await getPaymentMethods({
//         status: false,
//         user_id: cognitoId,
//       });
//       if (paymentMethods && paymentMethods.length > 0) {
//         setPaymentList(paymentMethods);
//         setSelectedPayment(
//           paymentMethods.find((item) => item.payment_method_type === "PAYPAL")
//         );
//         setLoading(false);
//       }
//     } catch (e) {
//       console.log("Error getting payment methods", e);
//     }
//   };

//   const { linkToken, loadingToken, error } = useLinkToken(cognitoId);
//   // const { open, ready } = usePlaidLink({
//   //   token: linkToken,
//   //   onSuccess: async (public_token, metadata) => {
//   //     await setAccessToken(public_token, metadata, cognitoId);
//   //     toast.success(`Your bank account has been connected.`);
//   //     getPaymentMethodList();
//   //   },
//   // });

//   const StyledButton = styled(SubmitBtn)`
//     background-color: ${settingData?.primary_color};
//   `;

//   if (loading) {
//     return (
//       <LoadingWrapper>
//         <CircularProgress disableShrink />
//       </LoadingWrapper>
//     );
//   }

//   return (
//     <div className="h-100">
//       <Sidebar currentWidth={currentWidth} setCurrentWidth={setCurrentWidth} />
//       <MainWrapper>
//         <ClientMainHeader
//           title="Connect your payment method"
//           description="Plaid makes it easy, safe and reliable for you to connect your
//               financial data to Pocketbook."
//           shortCut={shortCut}
//           setShortCut={setShortCut}
//         />
//         {/* <StyledButton onClick={() => open()}>Connect</StyledButton> */}
//         <StyledButton onClick={() => console.log(linkToken)}>
//           Connect
//         </StyledButton>
//       </MainWrapper>
//     </div>
//   );
// };

export default "";
